import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';

type TwilioRecordStartData = {
  callSid: string;
};

type TwilioRecordStartResponse = {
  url: string;
  extendedMessage: string;
};

const startTwilioRecord = (data: TwilioRecordStartData) => {
  const request: Request = {
    url: ENDPOINTS.call.twilio.recording.start,
    config: {
      method: 'POST',
      data: data,
    },
  };

  return client(request);
};

export default function useStartTwilioRecord({
  onSuccess,
}: {
  onSuccess?: (data: Response<TwilioRecordStartResponse>) => void;
} = {}) {
  return useMutation<
    Response<TwilioRecordStartResponse>,
    CronoError,
    TwilioRecordStartData
  >({
    mutationFn: startTwilioRecord,
    onSuccess,
  });
}
